import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"fill-height text-center",attrs:{"fluid":""}},[_c('div',{staticClass:"ma-auto"},[(_vm.isLoading)?_c(VProgressCircular,{attrs:{"size":70,"width":7,"color":"purple","indeterminate":""}}):_vm._e(),_c('p',[_vm._v("Wait check account Verification")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }